/**
 * MELATONINABACK Gift v1
 *
 * Ensures Melatonina is in the cart when the MELATONINABACK discount code
 * is applied. The Shopify Buy X Get Y discount handles the 100% off
 * natively — this script just needs to add the product to the cart.
 *
 * Flow:
 *   1. User applies MELATONINABACK code (via drawer, checkout, or URL)
 *   2. This script adds 1x Melatonina to cart (if not already present)
 *   3. Shopify's BXGY discount makes Melatonina free
 *   4. Kaching drawer refreshes to show updated cart
 *
 * When subtotal drops below R$199 or coupon is removed:
 *   - Removes Melatonina and clears discount
 */
(function () {
  'use strict';

  var MELATONINA_VARIANT_ID = 50847709462837;
  var COUPON_CODE = 'MELATONINABACK';
  var GIFT_PROPERTY_KEY = '_melatoninaback_gift';
  var MIN_SUBTOTAL = 19900; // R$199 in cents
  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  var giftAdded = false;
  var isProcessing = false;

  var safeFetch = window.__originalFetch || window.fetch.bind(window);

  // ── Helpers ──────────────────────────────────────────────────────────

  function getCart() {
    return safeFetch(ROOT + 'cart.js', {
      headers: { 'Accept': 'application/json' }
    }).then(function (r) { return r.json(); });
  }

  function melatoninaInCart(cart) {
    return cart.items.some(function (i) {
      return i.variant_id === MELATONINA_VARIANT_ID;
    });
  }

  function getSubtotalWithoutMelatonina(cart) {
    var subtotal = 0;
    cart.items.forEach(function (item) {
      // Exclui só a unidade de BRINDE (property), não a Melatonina comprada.
      // Excluir por variant_id zerava o subtotal de quem comprava só Melatonina.
      if (item.properties && item.properties[GIFT_PROPERTY_KEY] === 'true') return;
      subtotal += item.price * item.quantity;
    });
    return subtotal;
  }

  function isMelatoninabackCode(str) {
    return str && str.trim().toUpperCase() === COUPON_CODE;
  }

  // ── Core Actions ─────────────────────────────────────────────────────

  function addMelatonina() {
    if (isProcessing) return Promise.resolve(null);
    isProcessing = true;

    return safeFetch(ROOT + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({
        items: [{
          id: MELATONINA_VARIANT_ID,
          quantity: 1,
          properties: { '_melatoninaback_gift': 'true' }
        }]
      })
    }).then(function (r) {
      if (!r.ok) throw new Error('Add Melatonina failed: ' + r.status);
      giftAdded = true;
      isProcessing = false;
      return r.json();
    }).catch(function (err) {
      isProcessing = false;
      throw err;
    });
  }

  function removeMelatonina() {
    return getCart().then(function (cart) {
      for (var i = 0; i < cart.items.length; i++) {
        if (cart.items[i].variant_id === MELATONINA_VARIANT_ID &&
            cart.items[i].properties &&
            cart.items[i].properties[GIFT_PROPERTY_KEY] === 'true') {
          giftAdded = false;
          return safeFetch(ROOT + 'cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ line: i + 1, quantity: 0 })
          });
        }
      }
    });
  }

  // ── Hook into coupon inputs (Kaching drawer + theme component) ──────

  function hookCouponInputs() {
    // Capture phase so we run before any other handler
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('button');
      if (!btn) return;
      var text = btn.textContent.trim().toLowerCase();
      if (text !== 'aplicar' && text !== 'apply') return;

      var container = btn.closest('form, div, discount-code-component');
      if (!container) return;
      var input = container.querySelector('input[placeholder*="cupom"], input[placeholder*="desconto"], input[placeholder*="discount"], .discount-code-input');
      if (!input) return;

      var code = input.value.trim();
      if (!isMelatoninabackCode(code)) return;

      // It's MELATONINABACK — intercept!
      e.preventDefault();
      e.stopImmediatePropagation();

      var origBtnHTML = btn.innerHTML;
      btn.disabled = true;
      btn.innerHTML = '<svg width="20" height="20" viewBox="0 0 24 24" style="animation:melback-spin .8s linear infinite;vertical-align:middle"><circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="3" fill="none" stroke-dasharray="31.4 31.4" stroke-linecap="round"/></svg>';
      if (!document.getElementById('melback-spin-style')) {
        var style = document.createElement('style');
        style.id = 'melback-spin-style';
        style.textContent = '@keyframes melback-spin{to{transform:rotate(360deg)}}';
        document.head.appendChild(style);
      }

      (async function () {
        try {
          var cart = await getCart();
          var subtotal = getSubtotalWithoutMelatonina(cart);

          if (subtotal < MIN_SUBTOTAL) {
            alert('Subtotal mínimo de R$199 necessário para resgatar o brinde.');
            btn.innerHTML = origBtnHTML;
            btn.disabled = false;
            return;
          }

          if (!melatoninaInCart(cart)) {
            await addMelatonina();
            await new Promise(function (r) { setTimeout(r, 500); });
          } else {
            giftAdded = true;
          }

          await safeFetch(ROOT + 'cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ discount: code })
          });

          await new Promise(function (r) { setTimeout(r, 300); });
          btn.innerHTML = origBtnHTML;
          btn.disabled = false;
          if (window.kachingCartApi && window.kachingCartApi.refreshCart) {
            window.kachingCartApi.refreshCart();
          } else {
            window.location.reload();
          }
        } catch (err) {
          btn.innerHTML = origBtnHTML;
          btn.disabled = false;
          alert('Erro ao adicionar brinde. Tente novamente.');
        }
      })();
    }, true); // true = capture phase

    // Also intercept Enter key on coupon inputs
    document.addEventListener('keypress', function (e) {
      if (e.key !== 'Enter') return;
      var input = e.target;
      if (!input || !input.matches('input[placeholder*="cupom"], input[placeholder*="desconto"], input[placeholder*="discount"], .discount-code-input')) return;

      var code = input.value.trim();
      if (!isMelatoninabackCode(code)) return;

      e.preventDefault();
      e.stopImmediatePropagation();

      var container = input.closest('form, div');
      var btn = container ? container.querySelector('button') : null;
      if (btn) btn.click();
    }, true);
  }

  // ── Cart monitoring ──────────────────────────────────────────────────

  function watchCartChanges() {
    if (!window.theme || !window.theme.pubsub) return;

    window.theme.pubsub.subscribe(
      window.theme.pubsub.PUB_SUB_EVENTS.cartUpdate,
      function (event) {
        if (event.source === 'melatoninaback-gift') return;
        if (!giftAdded) return;

        setTimeout(function () {
          getCart().then(function (cart) {
            if (!melatoninaInCart(cart)) {
              giftAdded = false;
              return;
            }

            var subtotal = getSubtotalWithoutMelatonina(cart);
            if (subtotal < MIN_SUBTOTAL) {
              removeMelatonina().then(function () {
                return safeFetch(ROOT + 'cart/update.js', {
                  method: 'POST',
                  headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
                  body: JSON.stringify({ discount: '' })
                });
              }).then(function () {
                if (window.kachingCartApi && window.kachingCartApi.refreshCart) {
                  window.kachingCartApi.refreshCart();
                } else {
                  window.location.reload();
                }
              });
            }
          });
        }, 1000);
      }
    );
  }

  // ── /discount/MELATONINABACK URL support ────────────────────────────

  function handleDiscountURL() {
    if (!window.location.pathname.startsWith('/discount/')) return;
    var code = decodeURIComponent(window.location.pathname.replace('/discount/', ''));
    if (!isMelatoninabackCode(code)) return;

    getCart().then(function (cart) {
      if (getSubtotalWithoutMelatonina(cart) < MIN_SUBTOTAL) return;
      if (!melatoninaInCart(cart)) return addMelatonina();
      giftAdded = true;
    }).catch(function () {});
  }

  // ── Init ─────────────────────────────────────────────────────────────

  function syncGiftState() {
    getCart().then(function (cart) {
      if (melatoninaInCart(cart)) giftAdded = true;
    }).catch(function () {});
  }

  function init() {
    syncGiftState();
    handleDiscountURL();
    watchCartChanges();
    hookCouponInputs();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
